'use strict';

sellerCategoryService.$inject = ["SellerCategory", "api"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerCategoryService = sellerCategoryService;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/

function sellerCategoryService(SellerCategory, api) {
    return {
        get: get,
        getSellerCategories: getSellerCategories
    };

    function get(sellerId, sellerCategoryId) {
        return api.sellerCategory.get({ id: sellerId, categoryId: sellerCategoryId }).$promise.then(function (resource) {
            return SellerCategory.create(resource);
        });
    }

    function getSellerCategories(sellerId) {
        return api.sellerCategories.getSellerCategories({ sellerId: sellerId }).$promise.then(function (resourceList) {
            var categories = _lodash2.default.forEach(resourceList.categories, function (category) {
                return _lodash2.default.map(category.items, function (item) {
                    return SellerCategory.create(item);
                });
            });

            //cache.put('categories', categories);
            return categories;
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/sellerCategoryService.js
// module id = 829
// module chunks = 0